<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <textarea rows="3" class="form-control" :class="errorMessage ? 'is-invalid' : ''" v-model="value" />
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>
<script>
import FormLayout from "@/views/templates/FormLayout";
import BaseVuexFormItem from "@/views/molecules/formItems/BaseVuexFormItem";

export default {
  name: "VuexTextareaFormItem",
  extends: BaseVuexFormItem,
  components: {FormLayout},
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
  }
}
</script>
